postPreloader()
filterEvents();
pagination();
unsubmitForm();

// PRELOADER
function postPreloader() {
	return new Promise((resolve, reject) => {
		setTimeout(resolve, 1000);
	})
}
postPreloader()
	.then(() => {
		let preloaderEl = document.getElementById('preloader');
		if (preloaderEl) {
			preloaderEl.classList.add('hidden');
			preloaderEl.classList.remove('visible');
		}
	});

// PARSE DATA
function postData(url = '', data) {
	return fetch(url, {
		method: 'POST', // *GET, POST, PUT, DELETE, etc.
		mode: 'cors', // no-cors, cors, *same-origin
		cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
		credentials: 'same-origin', // include, *same-origin, omit
		// headers: {
		// 'Content-Type': 'application/json',
		// 'Content-Type': 'application/x-www-form-urlencoded',
		// },
		redirect: 'follow', // manual, *follow, error
		referrer: 'no-referrer', // no-referrer, *client
		body: data, // тип данных в body должен соответвовать значению заголовка "Content-Type"
	})
		.then(response => response.text()); // парсит JSON ответ в Javascript объект
}

// Filter Value
function filterValue() {
	let form = document.forms.namedItem('filterForm');
	if (form) {
		let inputs = form.elements,
			values = [],
			category_no = form.elements.namedItem('category_no').value,
			date = form.elements.namedItem('date').value.split(','),
			date_from = date[0],
			date_to = date[1],
			search_for = form.elements.namedItem('search_for').value,
			location = form.elements.namedItem('location').value;
		values.push(category_no, date_from, date_to, search_for, location)
		return values
	}
}

// Filter Events
function filterEvents() {
	let form = document.forms.namedItem('filterForm');
	if (form) {
		let inputs = form.elements,
			// Filter Query Parameters Declaration
			search;
		for (i = 0; i < inputs.length; i++) {
			inputs[i].addEventListener('input', function () {
				clearTimeout(search)
				search = setTimeout(() => {
					document.getElementById('preloader').classList.remove('hidden');
      		document.getElementById('preloader').classList.add('visible');
					filterAJAX(filterValue(), 1);
				}, 500)
			})
		}
	}
}

function pagination(pagin) {
	pagin = document.getElementById('eventsPaginator');
	if (pagin) {
		let page = pagin.querySelectorAll('a');
		page.forEach(link => {
			link.addEventListener('click', (e) => {
				e.preventDefault();
				document.getElementById('preloader').classList.remove('hidden');
      	document.getElementById('preloader').classList.add('visible');
				filterAJAX(filterValue(), link.dataset.page);
			})
		})
	}
}

function filterAJAX(values = [], page = 1) {
	let wrapp = document.getElementById('eventsWrapper');
	//event.preventDefault();
	// date_from = form.elements.namedItem('date_from').value;
	// date_to = form.elements.namedItem('date_to').value;
	data = {
		'action': 'filterevents',
		'category_no': values[0],
		'date_from': values[1],
		'date_to': values[2],
		'search_for': values[3],
		'location': values[4],
		'page': page
	}
	console.log(data);
	params = new URLSearchParams(data);
	postData(fs_ajax_params.ajaxurl, params)
		.then(data => {
			wrapp.innerHTML = data;
			document.getElementById('preloader').classList.add('hidden');
      document.getElementById('preloader').classList.remove('visible');
			pagination();
		})
		.catch(error => {
			console.error(error);
		});
}

function unsubmitForm() {
	let form = document.forms.namedItem('filterForm');
	if(form) {
		form.addEventListener('keydown', (e) => e.keyCode == 13 ? e.preventDefault() : true)
	}
}

jQuery().ready(function ($) {
	$('.featured-events-slider').each(function () {
		$(this).slick({
			dots: true,
			arrows: false,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						adaptiveHeight: true
					}
				}
			]
		});
	})
});